/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.

==========================================================================================*/

export default [
  {
    header: 'Dashboard',
    items: [
      {
        url: '/dashboard',
        name: 'Dashboard',
        slug: 'dashboard',
        icon: 'HomeIcon'
      }
    ]
  },
  {
    header: 'Simulations',
    items: [
    /*  {
        url: '/practice',
        name: 'Practice',
        slug: 'simulation-practice',
        icon: 'PlayIcon'
      }, */
      {
        url: '/simulation/search',
        name: 'Selector',
        slug: 'simulation-search',
        icon: 'PlayIcon'
      }
    ]
  },
  {
    header: 'Progress',
    rule: 'user',
    items: [
      {
        url: '/select-course',
        name: 'Courses',
        slug: 'course-selector',
        rule: 'user',
        icon: 'BookIcon'
      }
      // {
      //   url: '/simulation/bookmarks',
      //   name: 'Bookmarks',
      //   slug: 'simulation-bookmarks',simulations/legacy
      //   icon: 'BookmarkIcon'
      // }
    ]
  },
  {
    header: 'Management',
    rule: 'proctor',
    items: [
      {
        url: '/a/users',
        name: 'Users',
        slug: 'management-users',
        icon: 'UsersIcon',
        rule: 'proctor'
      },
      {
        url: '/a/groups',
        name: 'Groups',
        slug: 'management-users-groups',
        icon: 'TagIcon',
        rule: 'proctor'
      },
      {
        url: '',
        name: 'Guard',
        slug: 'management-guard',
        icon: 'ShieldIcon',
        rule: 'disabled'
      }
    ]
  },
  {
    header: 'Billing',
    rule: 'admin',
    items: [

      {
        url: '/a/subscriptions',
        name: 'Subscriptions',
        slug: 'management-subscriptions',
        rule: 'admin',
        icon: 'CreditCardIcon'
      }
    ]
  },
  {
    header: 'Proctor',
    rule: 'proctor',
    items: [
      {
        url: '/a/courses',
        name: 'Courses',
        slug: 'management-courses',
        icon: 'BookIcon',
        rule: 'proctor'
      },
      {
        url: '/a/simulations',
        name: 'Simulations',
        slug: 'management-simulations',
        icon: 'CodesandboxIcon'
      }
    ]
  }
]

